module.exports = __webpack_public_path__ + "web_static/img/nav_line.0cd1781e.png";